import React from 'react'
import PlaylistDetailsPage from './PlaylistDetailsPage'
import camelize from 'camelize'
import PropTypes from 'prop-types'
import { LightTheme } from 'ui/bend'
import { ThemeProvider } from 'styled-components'

const PlaylistDetails = (props) => {
    return (
      <ThemeProvider theme={LightTheme}>
        <PlaylistDetailsPage
          playlistObj={camelize(JSON.parse(props.playlist))}
          userIsAuthor={props.userIsAuthor}
          signedIn={props.signedIn}
        />
      </ThemeProvider> 
    )
}

PlaylistDetails.propTypes = {
  playlist: PropTypes.string,
  signedIn: PropTypes.bool,
  userIsAuthor: PropTypes.bool,
  userIsAdmin: PropTypes.bool
}

export default PlaylistDetails
